import { render, staticRenderFns } from "./CardDebitCard.vue?vue&type=template&id=45180a7c&scoped=true"
import script from "./CardDebitCard.vue?vue&type=script&lang=js"
export * from "./CardDebitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45180a7c",
  null
  
)

export default component.exports